import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const WHATSAPP_LINK = 'https://wa.me/5521974393072?text=Ol%C3%A1!%20Gostaria%20de%20uma%20consulta%20jur%C3%ADdica.';

const AREAS = [
  {
    icon: 'ri-user-heart-line',
    title: 'Direito Trabalhista',
    subtitle: 'Proteção dos seus direitos no trabalho',
    desc: 'Atuamos em reclamações trabalhistas, rescisões indevidas, verbas rescisórias, horas extras, assédio moral e todos os direitos garantidos pela CLT e Constituição Federal.',
    image: 'https://readdy.ai/api/search-image?query=Brazilian%20labor%20court%20justice%20scales%20worker%20rights%20warm%20earth%20tones%20professional%20legal%20concept%20dark%20wood%20gold%20accents%20minimalist%20sophisticated%20photography&width=600&height=400&seq=area001&orientation=landscape',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Direito do Consumidor',
    subtitle: 'Defesa nas relações de consumo',
    desc: 'Representamos consumidores lesados em cobranças indevidas, produtos defeituosos, negativações irregulares, serviços não prestados e danos morais decorrentes de relações de consumo.',
    image: 'https://readdy.ai/api/search-image?query=Consumer%20rights%20protection%20legal%20concept%20scales%20of%20justice%20warm%20tones%20brown%20gold%20sophisticated%20professional%20minimalist%20legal%20photography%20documentary%20dark%20wood%20desk&width=600&height=400&seq=area002&orientation=landscape',
  },
  {
    icon: 'ri-home-heart-line',
    title: 'Direito de Família',
    subtitle: 'Cuidado e suporte em momentos delicados',
    desc: 'Acompanhamos processos de divórcio, guarda de filhos, pensão alimentícia, inventário, partilha de bens e regularização de uniões estáveis com sensibilidade e profissionalismo.',
    image: 'https://readdy.ai/api/search-image?query=Family%20law%20concept%20warm%20cozy%20wooden%20table%20with%20legal%20documents%20family%20photo%20frame%20earth%20tones%20brown%20gold%20professional%20subtle%20sophisticated%20photography%20Brazil%20legal%20office&width=600&height=400&seq=area003&orientation=landscape',
  },
  {
    icon: 'ri-hospital-line',
    title: 'Direito Previdenciário',
    subtitle: 'Seus benefícios garantidos pelo INSS',
    desc: 'Auxiliamos na concessão e revisão de aposentadorias, pensões por morte, auxílio-doença, BPC/LOAS, auxílio-acidente e recursos contra indeferimentos do INSS.',
    image: 'https://readdy.ai/api/search-image?query=Social%20security%20pension%20law%20concept%20elder%20rights%20protection%20warm%20earth%20tones%20wooden%20desk%20legal%20documents%20gold%20details%20sophisticated%20professional%20Brazil%20INSS%20legal%20concept&width=600&height=400&seq=area004&orientation=landscape',
  },
];

export default function PracticeAreas() {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>();

  return (
    <section id="areas" className="py-24 lg:py-32 bg-marrom-escuro" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className={`text-center mb-16 reveal ${isVisible ? 'visible' : ''}`}>
          <span className="font-sans text-dourado-claro text-xs tracking-widest uppercase">
            O que fazemos
          </span>
          <h2 className="font-serif text-white text-4xl lg:text-5xl font-light mt-3 mb-4">
            Áreas de <span className="text-dourado-principal font-semibold">Atuação</span>
          </h2>
          <div className="w-14 h-0.5 bg-dourado-principal mx-auto mb-4" />
          <p className="font-sans text-white/60 text-base max-w-xl mx-auto">
            Especialização multidisciplinar para defender seus direitos com competência
            e estratégia em cada área do Direito.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {AREAS.map((area, idx) => (
            <div
              key={area.title}
              className={`reveal group relative overflow-hidden rounded-lg border border-white/10 hover:border-dourado-principal/40 transition-all duration-500 ${
                isVisible ? 'visible' : ''
              }`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              {/* Background Image */}
              <div className="absolute inset-0">
                <img
                  src={area.image}
                  alt={area.title}
                  className="w-full h-full object-cover object-center opacity-25 group-hover:opacity-35 transition-opacity duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-marrom-escuro via-marrom-escuro/80 to-marrom-escuro/60" />
              </div>

              {/* Content */}
              <div className="relative z-10 p-8">
                <div className="flex items-start gap-5 mb-5">
                  <div className="w-14 h-14 flex items-center justify-center bg-dourado-principal/15 border border-dourado-principal/30 rounded-lg flex-shrink-0 group-hover:bg-dourado-principal/25 transition-colors duration-300">
                    <i className={`${area.icon} text-dourado-principal text-2xl`} />
                  </div>
                  <div>
                    <h3 className="font-serif text-white text-2xl font-semibold leading-tight">
                      {area.title}
                    </h3>
                    <p className="font-sans text-dourado-claro text-xs tracking-wide mt-1">
                      {area.subtitle}
                    </p>
                  </div>
                </div>

                <p className="font-sans text-white/65 text-sm leading-relaxed mb-7">
                  {area.desc}
                </p>

                <a
                  href={WHATSAPP_LINK}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center gap-2 bg-dourado-principal hover:bg-dourado-medio text-marrom-escuro font-sans font-bold text-xs px-5 py-2.5 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-whatsapp-line text-sm" />
                  </div>
                  Falar com advogada
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
